import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import FusionCharts from 'fusioncharts';

import App from './App';
import theme from './theme';

FusionCharts.options.license({
  key:
    'bj1A1hwA-13F6B1H5D1J2A4B1C3B1C4B4A3yhbA5C5wsC-9gpD1A4kC-13nE2B4G1G3C2A5A4C4E3D1D4D2H2H3C10D7yf1g1D3E2D2pB6C1E3edsC1G4B1A-21D-16nB1A2B4mwuB14B1D8E3D5G2D4D1B2A16A7jB-13C-11E3A3OA1ptkE2GE2F1xzkB8C2C7C3B2G2I2H3A3D5E6C2B1D3s==',
  creditLabel: false
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
